import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Report } from '@/models/Report';
import Questionnaire from '@/components/Questionnaire/Questionnaire.vue';
import { DateFormatter } from '@/support/DateFormatter';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';

@Component<OverwriteIntermediaryDialog>({
  components: {
    Questionnaire,
  },
})
export default class OverwriteIntermediaryDialog extends Vue {
  @Prop()
  protected report!: Report;
  protected customIntermediaryName?: string;
  protected customIntermediaryEmail?: string;
  protected customIntermediaryPhone?: string;

  protected isLoading = true;


  protected async mounted(): Promise<void> {
    this.customIntermediaryName = this.report.custom_intermediary_name;
    this.customIntermediaryEmail = this.report.custom_intermediary_email;
    this.customIntermediaryPhone = this.report.custom_intermediary_phone;
    this.isLoading = false;
  }

  protected close(): void {
    this.$emit('input', false);
  }

  protected async updateIntermediary(): Promise<void> {
    if (! this.report) {
      return;
    }

    let payload = {
      custom_intermediary_name: this.customIntermediaryName,
      custom_intermediary_phone: this.customIntermediaryPhone,
      custom_intermediary_email: this.customIntermediaryEmail,
    };

    await new Report(this.report).update(payload)
      .then(() => {
        this.$emit('intermediary-updated');
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected get isValid(): boolean {
    return !! true;
  }
}